import script from "./WVenueSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./WVenueSelector.vue?vue&type=script&setup=true&lang=js"

import "./WVenueSelector.vue?vue&type=style&index=0&id=32793d70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32793d70"]])

export default __exports__